export enum EStatusBalancoEstoque {
    Aberto = 1,
    Finalizado = 2,
    Cancelado = 3
}
